import { MUTATION_TYPES } from './types';

export default {
  [MUTATION_TYPES.SET_VALIDATION_MESSAGES](state, validationMessages) {
    state.validationMessages = [
      ...new Map(
        [...state.validationMessages, ...validationMessages].map((x) => [
          x.id,
          x,
        ])
      ).values(),
    ];
  },
  [MUTATION_TYPES.SET_CURRENT_ACADEMIC_YEAR](state, academicYear) {
    state.currentAcademicYear = academicYear;
  },
};
